import React from "react";

export const PageTitle = (props) => {
  return (
    <header id="titlepage" className="inner-page-hero">
      <div className="container">
        <div className="inner-page-hero__text">
          <h1 className="inner-page-hero__title">{props.title}</h1>
          {props.title2 ? (
            <p className="inner-page-hero__line2">{props.title2}</p>
          ) : null}
          {props.title3 ? (
            <p className="inner-page-hero__line3">{props.title3}</p>
          ) : null}
          {props.title4 ? (
            <p className="inner-page-hero__line4">{props.title4}</p>
          ) : null}
          {props.sub ? (
            <p className="inner-page-hero__sub">{props.sub}</p>
          ) : null}
          {props.sub2 ? (
            <p className="inner-page-hero__sub2">{props.sub2}</p>
          ) : null}
        </div>
      </div>
    </header>
  );
};
